import React, { useState } from "react";
import styles from "./InfluencerProfile.module.css";
import CampaignInfo from "./CampaignInfo/CampaignInfo";
import BrandsInfo from "./BrandsInfo/BrandsInfo";
import ProfileInfo from "./ProfileInfo/ProfileInfo";
import Banner from "../../assets/images/banner.png";
import Media from "./Media";
import { FiMenu } from "react-icons/fi";
import { useSelector, useDispatch, connect } from "react-redux";
import DemographicsChart from "./ProfileInfo/DemoComp";

import { useNavigate } from "react-router-dom";
import { uploadImage } from "../../actions/UploadAction";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { FiHome, FiSettings } from "react-icons/fi";
import { TbDeviceAnalytics } from "react-icons/tb";
import { SiSpringCreators } from "react-icons/si";
import { BsChatSquareDots } from "react-icons/bs";
import { PiUsersThreeBold } from "react-icons/pi";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import { FaInstagram } from "react-icons/fa6";
import { MdOutlinePermMedia } from "react-icons/md";
import { AiOutlineYoutube } from "react-icons/ai";

import io from "socket.io-client";
import Instagram from "./instagram/Instagram";
import Youtube from "./youtube/Youtube";
import Settings from "./Settings/Settings";

//const socket = io("http://localhost:5000");

function InfluencerProfile({ AccessToken, handleCamapaignId }) {
  const location = useLocation();
  const { profile } = location.state || {};
  //console.log(profile)

  const param = useParams();
  const [preview, setPreview] = useState(null);
  //const [profileData, setprofileData] = useState(null);
  const [uploadPopup, setUploadpopup] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeTab, setActiveTab] = useState("pastCampaigns");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [leftActiveTab, setLeftActiveTab] = useState("profile");

  const campaignData = useSelector((state) => state.campaigns.campaigns?.data);
  //console.log(campaignData)

  let profileData = useSelector((state) => state.auth.authData?.user);
  //console.log(profileData)
  let isBrand = false;

  if (profileData?.userType === "Brand") {
    isBrand = true;
    profileData = profile;
  }

  const toggleTab = (tab) => {
    setActiveTab(tab);
  };

  const handleUserUpdate = () => {
    const id = profileData._id;
    navigate(`/influencer/update/${id}`);
  };

  const closePopup = () => {
    setUploadpopup(!uploadPopup);
  };
  const handleImagePopup = (e) => {
    e.preventDefault();
    setUploadpopup(!uploadPopup);
  };

  const handleImageUpload = (e) => {
    e.preventDefault();
    const file = e.target.files[0];

    if (file) {
      setSelectedImage(file);
      //console.log(selectedImage)
      setPreview(URL.createObjectURL(file));
    }
  };

  const updateProfileImage = async () => {
    const influencerId = param.id;
    console.log("Selected Image URL: ", selectedImage);

    if (!selectedImage) {
      console.error("No image selected");
      return;
    }
    setUploadpopup(!uploadPopup);

    const filedata = new FormData();
    const fileName = Date.now() + selectedImage.name;
    filedata.append("name", fileName);
    filedata.append("file", selectedImage);
    try {
      await dispatch(uploadImage(influencerId, filedata));
    } catch (err) {
      console.log(err);
    }
  };

  const memberSince = () => {
    const date = new Date(profileData.createdAt);
    const month = date.toLocaleString("default", { month: "long" }); // Returns full month name (e.g., 'September')
    const year = date.getFullYear(); // Returns year (e.g., 2024)

    // Concatenate month and year
    const monthYear = `${month} ${year}`;
    return monthYear;
  };

  const tabs = [
    {
      name: "profile",
      icon: <FiHome />,
      label: "Profile",
    },
    {
      name: "instagram",
      icon: <FaInstagram />,
      label: "Instagram",
    },

    // {
    //   name: "dashboard",
    //   icon: <TbDeviceAnalytics />,
    //   label: "Dashboard",
    // },

    {
      name: "youtube",
      icon: <AiOutlineYoutube />,
      label: "Youtube",
    },

    {
      name: "campaign",
      icon: <PiUsersThreeBold />,
      label: "Campaign",
    },

    {
      name: "settings",
      icon: <FiSettings />,
      label: "Settings",
    },
  ];
  return (
    <>
      <div className={styles.influencerProfile}>
        {/* Banner Section */}

        <div
          className="flex flex-col md:flex-row "
          style={{ fontFamily: "Gilroy-Medium" }}
        >
          {/* Sidebar (Hidden on small screens) */}
          <div
            className={`md:w-40 xs:w-auto bg-[#ff006b] h-[50%]   ml-4 mt-4 py-4 pl-4 rounded-[10px]  `}
          >
            <div className=" font-semibold text-white md:block hidden ">
              Creator's Hub
            </div>

            <div className="flex flex-wrap xs:flex-row md:flex-col height-auto">
              {tabs.map((tab, index) => (
                <li
                  key={tab.name}
                  className={`
      p-2 mt-2 flex items-center justify-center md:justify-start cursor-pointer
      rounded-bl-full rounded-tl-full
      ${
        leftActiveTab === tab.name
          ? "bg-white text-black font-semibold"
          : "text-white "
      }
    `}
                  onClick={() => setLeftActiveTab(tab.name)}
                >
                  <span className="mr-0 md:mr-2">{tab.icon}</span>
                  <span className="hidden md:inline">{tab.label}</span>
                </li>
              ))}
            </div>
          </div>

          {/* Right Content Area */}
          <div className="flex-1 p-6  overflow-y-auto h-screen max-h-[calc(100vh-4rem)]">
            {leftActiveTab === "profile" && (
              <ProfileInfo
                profileData={profileData}
                isBrand={isBrand}
                handleUserUpdate={handleUserUpdate}
              />
            )}

            {leftActiveTab === "instagram" && (
              <Instagram isBrand={isBrand} profileData={profileData} />
            )}

            {leftActiveTab === "youtube" && (
              <Youtube isBrand={isBrand} profileData={profileData} />
            )}
            {leftActiveTab === "campaign" && (
              <div>
                <CampaignInfo
                  campaignData={campaignData}
                  handleCamapaignId={handleCamapaignId}
                />
              </div>
            )}

            {leftActiveTab === "settings" && (
              <Settings
                profileData={profileData}
                isBrand={isBrand}
                handleUserUpdate={handleUserUpdate}
              />
            )}
          </div>
        </div>

        {!isBrand && (
          <div className={styles.ButtonDiv}>
            <button
              className="btn btn-warning rounded-5 fw-bold"
              onClick={handleUserUpdate}
            >
              Update
            </button>
          </div>
        )}
      </div>
    </>
  );
}

export default InfluencerProfile;
